module.exports = __webpack_public_path__ + "static/img/340b03b0623ac6995ee103554ba9b5e.ab09ba7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/340b03b0623ac6995ee103554ba9b5e.png
// module id = xD1A
// module chunks = 0